import {
  scheduleTask,
  scheduleCreation,
  scheduleUpdate
} from 'gleam-shared/network/task'

window.task = {
  scheduleTask,
  scheduleCreation,
  scheduleUpdate
}
